import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { api } from "../../lib/api";

const near = (c) => (/^[aeiouyàâéèêëîïôûùh]/i.test(c) ? `près d’${c}` : `près de ${c}`);
const TXT = {
  en: {
    head: (n, b, c) => `${n} ${n === 1 ? "person is" : "people are"} waiting for ${b}${c ? ` near ${c}` : ""}`,
    parts: { alerts: ["alert sign-up", "alert sign-ups"], saved_searches: ["saved search", "saved searches"], followers: ["follower", "followers"] },
    sub: "They'll hear about it when you post. Counts only — no names are shared.",
  },
  fr: {
    head: (n, b, c) => `${n} ${n === 1 ? "personne attend" : "personnes attendent"} des ${b}${c ? ` ${near(c)}` : ""}`,
    parts: { alerts: ["inscription aux alertes", "inscriptions aux alertes"], saved_searches: ["recherche enregistrée", "recherches enregistrées"], followers: ["abonné", "abonnés"] },
    sub: "Elles seront avisées quand vous publierez. Chiffres seulement — aucun nom n'est partagé.",
  },
};

export function WaitingBoost({ species, breed, lang }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const b = breed.trim();
    if (b.length < 2) { setD(null); return undefined; }
    const ctrl = new AbortController();
    const tm = setTimeout(() => {
      api.post("/my/litters/waiting", { species, breed: b }, { signal: ctrl.signal }).then((r) => setD(r.data)).catch(() => {});
    }, 600);
    return () => { clearTimeout(tm); ctrl.abort(); };
  }, [species, breed]);
  if (!d?.enabled || !d.total) return null;
  const t = TXT[lang] || TXT.en;
  const parts = ["alerts", "saved_searches", "followers"].filter((k) => d[k]).map((k) => `${d[k]} ${t.parts[k][d[k] === 1 ? 0 : 1]}`);
  return (
    <div className="rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-2.5 flex gap-2.5" data-testid="litter-waiting-boost">
      <Users size={18} className="text-emerald-700 shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-bold text-emerald-800" data-testid="litter-waiting-total">{t.head(d.total, d.breed, d.city)}</p>
        <p className="text-xs text-emerald-700" data-testid="litter-waiting-parts">{parts.join(" · ")}</p>
        <p className="text-[11px] text-emerald-700/80 mt-0.5">{t.sub}</p>
      </div>
    </div>
  );
}
